export default __webpack_public_path__ + "static/media/referralBanner.30c03dfd.jpg";